module.exports = __webpack_public_path__ + "static/media/is.1eecf71d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/is.svg
// module id = 1263
// module chunks = 0